import type { Reaction } from '@moussenaires/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { feedApi } from '../api/feed.js';
import './ReactionBar.css';

const QUICK_EMOJI = ['🔥', '😂', '💀', '❤️', '👍'];

export function ReactionBar({ postId, reactions }: { postId: number; reactions: Reaction[] }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const toggleMutation = useMutation({
    mutationFn: (emoji: string) => feedApi.toggleReaction(postId, emoji),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['feed'] }),
  });

  const activeEmoji = new Set(reactions.map((reaction) => reaction.emoji));

  return (
    <div className="reaction-bar">
      {reactions.map((reaction) => (
        <button
          key={reaction.emoji}
          type="button"
          className={`reaction-pill ${reaction.reacted ? 'reaction-pill-active' : ''}`}
          onClick={() => toggleMutation.mutate(reaction.emoji)}
        >
          {reaction.emoji} <span>{reaction.count}</span>
        </button>
      ))}
      {QUICK_EMOJI.filter((emoji) => !activeEmoji.has(emoji)).map((emoji) => (
        <button
          key={emoji}
          type="button"
          className="reaction-pill reaction-pill-ghost"
          onClick={() => toggleMutation.mutate(emoji)}
          aria-label={`${t('feed.react')} ${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}
